var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cz-tab-head"},[_vm._t("default"),_c('div',{staticClass:"extra"},[_vm._t("extra")],2),_c('div',{staticClass:"boder-bottom"}),_c('div',{ref:"line",staticClass:"line"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }